import { BACKEND_URL } from "../../views/common/utils/constants"
import { IAPIResponse } from "../../views/common/utils/interfaces"
import { errorToastify } from "../../views/common/utils/Toasty"
import { extractErrorMsg } from "../../views/common/utils/validation"
import { CustomAxios } from "../customAxios"

export const getTransactionDetails = async (id: string) => {
    try {
        const { data: result  } : IAPIResponse = await CustomAxios().get(`${BACKEND_URL}/payments/buyer-transactions/${id}`)
        if(!result.status) {
            throw new Error(result.message);
        }
        return result.data;
    } catch (error) {
        if (typeof error === "string") {
            errorToastify(error)
        }
    }
}